/**
 * price-utils.js - Shared price formatting utilities
 * DRY: Used by bundle selectors and product.js
 * Single Responsibility: Price formatting only
 */
var PriceUtils = (function() {
  'use strict';

  /**
   * Parse price with validation and fallback
   * @param {string|number} value - Price value to parse
   * @param {number} defaultValue - Fallback value if invalid
   * @returns {number} Parsed price in cents
   */
  function parsePrice(value, defaultValue) {
    if (defaultValue === undefined) defaultValue = 0;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? defaultValue : parsed;
  }

  /**
   * Format price using shop money format
   * @param {number|string} cents - Price in cents
   * @returns {string} Formatted price string
   */
  function formatPrice(cents) {
    if (!cents && cents !== 0) return '';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = parseFloat(cents) / 100;
    const currencyMeta = document.querySelector('meta[name="cart-currency"]');
    const currencyCode = (currencyMeta && currencyMeta.getAttribute('content')) ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      'USD';
    const dollarCodes = { CAD: true, USD: true, AUD: true, NZD: true, SGD: true, HKD: true };

    try {
      const formatted = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: dollarCodes[currencyCode] ? 'narrowSymbol' : 'symbol'
      }).format(value);
      return dollarCodes[currencyCode] ? `${formatted} ${currencyCode}` : formatted;
    } catch (e) {}
    
    const meta = document.querySelector('meta[name="money-format"]');
    const formatString = meta ? meta.getAttribute('content') : '${{amount}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = formatString.match(placeholderRegex);
    
    if (!match) return formatString;
    
    const placeholder = match[1];
    let formattedValue;
    
    switch (placeholder) {
      case 'amount':
        formattedValue = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case 'amount_no_decimals':
        formattedValue = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case 'amount_with_comma_separator':
        formattedValue = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      default:
        formattedValue = value.toFixed(2);
    }
    
    return formatString.replace(placeholderRegex, formattedValue);
  }

  /**
   * Calculate discount percentage
   * @param {number} comparePrice - Original price
   * @param {number} price - Sale price
   * @returns {number} Discount percentage (0-100)
   */
  function calculateDiscount(comparePrice, price) {
    if (!comparePrice || !price || comparePrice <= price) return 0;
    return Math.round(((comparePrice - price) / comparePrice) * 100);
  }

  return {
    parsePrice: parsePrice,
    formatPrice: formatPrice,
    calculateDiscount: calculateDiscount
  };
})();
